import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { store } from "../../utils/httpUtil";

export const searchStaffDetailWithCriteria = createAsyncThunk(
  "hr-chart/staff-detail",
  async (payload) => {
    try {
      const response = await store("v1/hr-chart/staff-detail", payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const searchStaffResignedWithCriteria = createAsyncThunk(
  "hr-chart/staff-resigned",
  async (payload) => {
    try {
      const response = await store("v1/hr-chart/staff-resigned", payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const searchTerminatedStaffWithCriteria = createAsyncThunk(
  "hr-chart/staff-terminated",
  async (payload) => {
    try {
      const response = await store("v1/hr-chart/staff-terminated", payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const searchTransferTrainingWithCriteria = createAsyncThunk(
  "hr-chart/transfer-training",
  async (payload) => {
    try {
      const response = await store("v1/hr-chart/transfer-training", payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const searchStaffTurnOverRatioWithCriteria = createAsyncThunk(
  "hr-chart/staff/turnover/ratio",
  async (payload) => {
    try {
      const response = await store("v1/hr-chart/ratio-chart", payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const searchStaffTransferTrainingRatioWithCriteria = createAsyncThunk(
  "hr-chart/transfer/training/ratio",
  async (payload) => {
    try {
      const response = await store("v1/hr-chart/transfer/training-ratio-chart", payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

const staffDetailPending = ["hr-chart/staff-detail/pending"];
const staffDetailFulfilled = ["hr-chart/staff-detail/fulfilled"];
const staffDetailRejected = ["hr-chart/staff-detail/rejected"];

const staffResignedPending = ["hr-chart/staff-resigned/pending"];
const staffResignedFulfilled = ["hr-chart/staff-resigned/fulfilled"];
const staffResignedRejected = ["hr-chart/staff-resigned/rejected"];

const staffTerminatedPending = ["hr-chart/staff-terminated/pending"];
const staffTerminatedFulfilled = ["hr-chart/staff-terminated/fulfilled"];
const staffTerminatedRejected = ["hr-chart/staff-terminated/rejected"];

const transferTrainingPending = ["hr-chart/transfer-training/pending"];
const transferTrainingFulfilled = ["hr-chart/transfer-training/fulfilled"];
const transferTrainingRejected = ["hr-chart/transfer-training/rejected"];

const staffTurnOverRatioPending = ["hr-chart/staff/turnover/ratio/pending"];
const staffTurnOverRatioFulfilled = ["hr-chart/staff/turnover/ratio/fulfilled"];
const staffTurnOverRatioRejected = ["hr-chart/staff/turnover/ratio/rejected"];

const transferTrainingRatioPending = ["hr-chart/transfer/training/ratio/pending"];
const transferTrainingRatioFulfilled = ["hr-chart/transfer/training/ratio/fulfilled"];
const transferTrainingRatioRejected = ["hr-chart/transfer/training/ratio/rejected"];

export const hrChartSlice = createSlice({
  name: "hrChart",
  initialState: {
    staffDetailPayload: [],
    staffDetailLoading: false,
    staffDetailErrors: {},

    staffResignedPayload: [],
    staffResignedLoading: false,
    staffResignedErrors: {},

    staffTerminatedPayload: [],
    staffTerminatedLoading: false,
    staffTerminatedErrors: {},

    transferTrainingPayload: [],
    transferTrainingLoading: false,
    transferTrainingErrors: {},

    staffTurnOverRatioPayload: [],
    staffTurnOverRatioLoading: false,
    staffTurnOverRatioErrors: {},

    transferTrainingRatioPayload: [],
    transferTrainingRatioLoading: false,
    transferTrainingRatioErrors: {},
  },
  reducers: {
    cleanHrChart(state) {
      state.staffDetailPayload = [];
      state.staffDetailLoading = false;
      state.staffDetailErrors = {};

      state.staffResignedPayload = [];
      state.staffResignedLoading = false;
      state.staffResignedErrors = {};

      state.staffTerminatedPayload = [];
      state.staffTerminatedLoading = false;
      state.staffTerminatedErrors = {};

      state.transferTrainingPayload = [];
      state.transferTrainingLoading = false;
      state.transferTrainingErrors = {};

      state.staffTurnOverRatioPayload = [];
      state.staffTurnOverRatioLoading = false;
      state.staffTurnOverRatioErrors = {};

      state.transferTrainingRatioPayload = [];
      state.transferTrainingRatioLoading = false;
      state.transferTrainingRatioErrors = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) => staffDetailPending.includes(action.type),
        (state) => {
          state.staffDetailLoading = true;
        }
      )
      .addMatcher(
        (action) => staffDetailFulfilled.includes(action.type),
        (state, action) => {
          state.staffDetailLoading = false;
          state.staffDetailPayload = action.payload?.data;
        }
      )
      .addMatcher(
        (action) => staffDetailRejected.includes(action.type),
        (state, action) => {
          state.staffDetailLoading = false;
          state.staffDetailErrors = action.error;
        }
      )
      .addMatcher(
        (action) => staffResignedPending.includes(action.type),
        (state) => {
          state.staffResignedLoading = true;
        }
      )
      .addMatcher(
        (action) => staffResignedFulfilled.includes(action.type),
        (state, action) => {
          state.staffResignedLoading = false;
          state.staffResignedPayload = action.payload?.data;
        }
      )
      .addMatcher(
        (action) => staffResignedRejected.includes(action.type),
        (state, action) => {
          state.staffResignedLoading = false;
          state.staffResignedErrors = action.error;
        }
      )
      .addMatcher(
        (action) => staffTerminatedPending.includes(action.type),
        (state) => {
          state.staffTerminatedLoading = true;
        }
      )
      .addMatcher(
        (action) => staffTerminatedFulfilled.includes(action.type),
        (state, action) => {
          state.staffTerminatedLoading = false;
          state.staffTerminatedPayload = action.payload?.data;
        }
      )
      .addMatcher(
        (action) => staffTerminatedRejected.includes(action.type),
        (state, action) => {
          state.staffTerminatedLoading = false;
          state.staffTerminatedErrors = action.error;
        }
      )
      .addMatcher(
        (action) => transferTrainingPending.includes(action.type),
        (state) => {
          state.transferTrainingLoading = true;
        }
      )
      .addMatcher(
        (action) => transferTrainingFulfilled.includes(action.type),
        (state, action) => {
          state.transferTrainingLoading = false;
          state.transferTrainingPayload = action.payload?.data;
        }
      )
      .addMatcher(
        (action) => transferTrainingRejected.includes(action.type),
        (state, action) => {
          state.transferTrainingLoading = false;
          state.transferTrainingErrors = action.error;
        }
      )
      .addMatcher(
        (action) => staffTurnOverRatioPending.includes(action.type),
        (state) => {
          state.staffTurnOverRatioLoading = true;
        }
      )
      .addMatcher(
        (action) => staffTurnOverRatioFulfilled.includes(action.type),
        (state, action) => {
          state.staffTurnOverRatioLoading = false;
          state.staffTurnOverRatioPayload = action.payload?.data?.staff_turnover_ratio;
        }
      )
      .addMatcher(
        (action) => staffTurnOverRatioRejected.includes(action.type),
        (state, action) => {
          state.staffTurnOverRatioLoading = false;
          state.staffTurnOverRatioErrors = action.error;
        }
      )
      .addMatcher(
        (action) => transferTrainingRatioPending.includes(action.type),
        (state, action) => {
          state.transferTrainingRatioLoading = true;
          state.transferTrainingRatioErrors = action.error;
        }
      )
      .addMatcher(
        (action) => transferTrainingRatioFulfilled.includes(action.type),
        (state, action) => {
          state.transferTrainingRatioLoading = false;
          state.transferTrainingRatioPayload = action.payload?.data;
          state.transferTrainingRatioErrors = action.error;
        }
      )
      .addMatcher(
        (action) => transferTrainingRatioRejected.includes(action.type),
        (state, action) => {
          state.transferTrainingRatioLoading = false;
          state.transferTrainingRatioErrors = action.error;
        }
      );
  },
});

export const { cleanHrChart } = hrChartSlice.actions;
export default hrChartSlice;
